// Update FacetWP Load More button text based on data attribute
if (typeof window !== "undefined") {
	document.addEventListener("facetwp-loaded", function () {
		document
			.querySelectorAll("[data-custom-loadmore-text]")
			.forEach(function (container) {
				var customText = container.getAttribute("data-custom-loadmore-text");
				var btn = container.querySelector(".facetwp-load-more");
				if (btn && customText) {
					btn.textContent = customText;
				}
			});
	});
}
